/* eslint-disable react/destructuring-assignment */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';

import noop from 'lodash/noop';
import _isEqual from 'lodash/isEqual';

import Button from 'components/Button';

// @ts-ignore
import { ModalHeader, ModalBody, ModalFooter } from 'components/Modal';
import Form, { FormGroupFile } from 'components/Form';
import FORM_NAMES from 'constants/formNames';

import FilePreview from './components/FilePreview';
import './style.scss';

export class UploadFileModalContent extends Component {
  static propTypes = {
    files: PropTypes.arrayOf(PropTypes.object).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isUploading: PropTypes.bool.isRequired,
    resetUploadFiles: PropTypes.func.isRequired,
    uploadFiles: PropTypes.func.isRequired,
    className: PropTypes.string,
    isFlow: PropTypes.bool,
    onCloseRequest: PropTypes.func,
  };

  static defaultProps = {
    onCloseRequest: noop,
    className: '',
    isFlow: false,
  };

  // isFlow prop is a workarround in order to avoid
  // https://jira.omilia.com:8443/browse/CONVO-1164
  state = {
    files: this.props.isFlow ? this.props.files : [],
  };

  componentWillReceiveProps({ files }) {
    if (this.props.isFlow) return;
    if (files.length && !_isEqual(files, this.state.files)) {
      this.setState({
        files,
      });
    }
  }

  onDelete = fileName => {
    this.setState(prevState => ({
      files: prevState.files.filter(f => f.name !== fileName),
    }));
  };

  handleKeyDown = e => {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();
      this.props.uploadFiles(this.state.files);
    }
  };

  handleUpload = async () => {
    await this.props.uploadFiles(this.state.files);
  };

  handleClose = () => {
    this.props.resetUploadFiles();
    this.props.onCloseRequest();
  };

  handleOnChange = files => {
    this.setState(prevState => ({
      files: [...prevState.files, ...Object.keys(files).map(key => files[key])],
    }));
  };

  render() {
    const { isUploading, className } = this.props;

    const { files } = this.state;

    return (
      <Form
        className={className}
        onKeyDown={this.handleKeyDown}
        onSubmit={this.props.handleSubmit(this.handleUpload)}
      >
        <ModalHeader
          icon={<span className="icon-upload" />}
          title="Upload files"
        />

        <ModalBody isGrey styleName="flex-grid">
          <Field
            multiple
            component={FormGroupFile}
            description="files"
            icon={<i className="icon-import-project" />}
            name="file"
            onChangeFiles={this.handleOnChange}
          />
          <Grid styleName="flex-grid">
            <Row className="flex-row">
              <Col className="flex-col" xs={12}>
                {files.map(f => (
                  <FilePreview key={f.name} file={f} onDelete={this.onDelete} />
                ))}
              </Col>
            </Row>
          </Grid>
        </ModalBody>

        <ModalFooter justifyContent="flex-end">
          <Button
            isLarge
            isTransparent
            data-test="cancel-upload-files"
            type="button"
            onClick={this.handleClose}
          >
            Cancel
          </Button>

          <Button
            isLarge
            data-test="submit-upload-files"
            disabled={isUploading || !files.length}
            isLoading={isUploading}
            type="submit"
          >
            Upload
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

const validate = ({ file, encoding, separator }) => {
  const errors = {};

  if (!file) {
    errors.file = 'Select file';
  }

  if (!encoding) {
    errors.encoding = 'Select encoding';
  }

  if (!separator) {
    errors.separator = 'Select separator';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: FORM_NAMES.FILES.UPLOAD,
})(UploadFileModalContent);
